import { SelectField } from "$components/inputs";
import React from "react";
import { useIntl } from "react-intl";
import { InvoiceFilterStatus } from "./types";

const InvoiceStatusFilter = ({
  setInvoiceStatus,
  invoiceStatus,
}: {
  invoiceStatus?: InvoiceFilterStatus;
  setInvoiceStatus: (value: InvoiceFilterStatus) => void;
}) => {
  const { formatMessage } = useIntl();

  const selectLabel = formatMessage({
    id: "invoices.filter.type.label",
    defaultMessage: "Invoice Type",
  });
  const invoiceStatusOptions = React.useMemo(
    () => [
      {
        value: "ALL",
        label: formatMessage({
          id: "invoices.filter.all.label",
          defaultMessage: "All",
        }),
      },
      {
        value: InvoiceFilterStatus.PAID,
        label: formatMessage({
          id: "invoices.filter.paid.label",
          defaultMessage: "Paid",
        }),
      },
      {
        value: InvoiceFilterStatus.UNPAID,
        label: formatMessage({
          id: "invoices.filter.unpaid.label",
          defaultMessage: "Unpaid",
        }),
      },
      {
        value: InvoiceFilterStatus.PENDING,
        label: formatMessage({
          id: "invoices.filter.pending.label",
          defaultMessage: "Pending payment",
        }),
      },
      {
        value: InvoiceFilterStatus.REFUNDED,
        label: formatMessage({
          id: "invoices.filter.refunded.label",
          defaultMessage: "Refunded",
        }),
      },
      {
        value: InvoiceFilterStatus.VOID,
        label: formatMessage({
          id: "invoices.filter.void.label",
          defaultMessage: "Void",
        }),
      },
    ],
    [formatMessage],
  );

  return (
    <SelectField
      label={selectLabel}
      options={invoiceStatusOptions}
      fullWidth
      hideHelper
      name={"invoiceStatusFilter"}
      id={"invoice-status-filter-select"}
      selectProps={{
        role: "spinbutton",
        value: invoiceStatus,
        onChange: (e: React.ChangeEvent<HTMLSelectElement>) =>
          setInvoiceStatus(e.target.value as InvoiceFilterStatus),
      }}
    />
  );
};

export default InvoiceStatusFilter;
